// extracted by mini-css-extract-plugin
module.exports = {"menuList":"MenuList_menuList__jWQvZ","panel":"MenuList_panel__HCAkO"};